var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timeline-stop__time timeline-stop__title"},[_vm._v(" Pickup time: "+_vm._s(_setup.stopTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }